module.exports = __webpack_public_path__ + "static/media/hutui.0b9fb43c.png";